import { render, staticRenderFns } from "./originAddComponent.vue?vue&type=template&id=74dfa053&scoped=true&"
import script from "./originAddComponent.vue?vue&type=script&lang=js&"
export * from "./originAddComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfa053",
  null
  
)

export default component.exports